import { useEffect, useRef } from 'react';
import useStrategyDashboardStore from '../Stores/strategyDashboardStore';

import { PREMIUM_SELLERS_WS_URL } from './websocketUrls';
import {
  buildPremiumSellersAuthPayload,
  getAuthMode,
} from './buildAuthPayload';

function logStrategyPayload(message) {
  const strategies = message?.strategies || {};
  const dashboardOverview = message?.dashboard_overview || {};
  const tradeSignals = dashboardOverview?.trade_signals || {};
  const tradeTracking = dashboardOverview?.trade_tracking || {};

  const argosPayload = strategies?.argos;
  const accePayload = strategies?.acce;
  const gemicPayload = strategies?.gemic;
  const meicPayload = strategies?.meic;

  // console.log('[STRATEGY DASHBOARD WS] Snapshot received:', {
  //   asofTs: message.asof_ts,
  //   marketDate: message.market_date,
  //   activePositions: message.dashboard_overview?.summary?.active_positions_count,
  //   closedToday: message.dashboard_overview?.summary?.closed_today_count,
  //   strategyKeys: Object.keys(strategies),
  // });

  // console.log('[STRATEGY DASHBOARD WS] FULL strategies object:', strategies);

  // console.log('[STRATEGY DASHBOARD WS] ARGOS payload:', argosPayload);
  // console.log(
  //   '[STRATEGY DASHBOARD WS] ARGOS payload keys:',
  //   argosPayload ? Object.keys(argosPayload) : null
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] ARGOS recent_trades count:',
  //   argosPayload?.recent_trades?.length
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] First ARGOS recent trade:',
  //   argosPayload?.recent_trades?.[0]
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] ARGOS open_positions count:',
  //   argosPayload?.open_positions?.length
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] First ARGOS open position:',
  //   argosPayload?.open_positions?.[0]
  // );

  // console.log('[STRATEGY DASHBOARD WS] ACCE payload:', accePayload);

  // console.log(
  //   '[STRATEGY DASHBOARD WS] ACCE recent_trades count:',
  //   accePayload?.recent_trades?.length
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] First ACCE recent trade:',
  //   accePayload?.recent_trades?.[0]
  // );

  // console.log('[STRATEGY DASHBOARD WS] GEMIC payload:', gemicPayload);

  // console.log(
  //   '[STRATEGY DASHBOARD WS] GEMIC recent_trades count:',
  //   gemicPayload?.recent_trades?.length
  // );

  // console.log('[STRATEGY DASHBOARD WS] MEIC payload:', meicPayload);

  // console.log(
  //   '[STRATEGY DASHBOARD WS] MEIC daily_equity_history count:',
  //   meicPayload?.daily_equity_history?.length
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] First MEIC daily equity row:',
  //   meicPayload?.daily_equity_history?.[0]
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] Latest MEIC equity row:',
  //   meicPayload?.latest_equity
  // );

  // console.log('[STRATEGY DASHBOARD WS] trade_signals:', tradeSignals);
  // console.log('[STRATEGY DASHBOARD WS] ARGOS signal:', tradeSignals?.argos);
  // console.log('[STRATEGY DASHBOARD WS] ACCE signal:', tradeSignals?.acce);
  // console.log('[STRATEGY DASHBOARD WS] GEMIC signal:', tradeSignals?.gemic);

  // console.log('[STRATEGY DASHBOARD WS] trade_tracking:', tradeTracking);

  // console.log(
  //   '[STRATEGY DASHBOARD WS] trade_tracking open_positions:',
  //   tradeTracking?.open_positions
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] ARGOS open positions from tracking:',
  //   (tradeTracking?.open_positions || []).filter(position =>
  //     String(position?.strategy_key || position?.strategy || '').toLowerCase() === 'argos'
  //   )
  // );

  // console.log(
  //   '[STRATEGY DASHBOARD WS] ARGOS closed today from tracking:',
  //   (tradeTracking?.closed_today || []).filter(position =>
  //     String(position?.strategy_key || position?.strategy || '').toLowerCase() === 'argos'
  //   )
  // );
}

export default function StrategyDashboardClient() {
  const wsRef = useRef(null);
  const reconnectTimerRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  const manuallyClosedRef = useRef(false);
  const authFailedRef = useRef(false);

  useEffect(() => {
    manuallyClosedRef.current = false;
    authFailedRef.current = false;

    const store = useStrategyDashboardStore.getState();

    async function sendAuth(ws) {
      if (!ws || ws.readyState !== WebSocket.OPEN) return;

      try {
        const authPayload = await buildPremiumSellersAuthPayload();

        // console.log('[STRATEGY DASHBOARD WS] Sending AUTH payload:', {
        //   mode: getAuthMode(),
        //   type: authPayload.type,
        //   memberId: authPayload.memberId,
        //   planId: authPayload.planId,
        //   status: authPayload.status,
        // });

        ws.send(JSON.stringify(authPayload));
      } catch (error) {
        // console.error('[STRATEGY DASHBOARD WS] Failed to build/send AUTH:', error);

        authFailedRef.current = true;
        manuallyClosedRef.current = true;

        useStrategyDashboardStore.getState().setConnected(false);
        useStrategyDashboardStore.getState().setAuthenticated(false);
        useStrategyDashboardStore.getState().setWebSocketRef(null);

        useStrategyDashboardStore
          .getState()
          .setError(
            error.message || 'Strategy dashboard authentication failed'
          );

        if (
          ws &&
          (ws.readyState === WebSocket.OPEN ||
            ws.readyState === WebSocket.CONNECTING)
        ) {
          ws.close();
        }
      }
    }

    function connect() {
      if (manuallyClosedRef.current || authFailedRef.current) {
        return;
      }

      const ws = new WebSocket(PREMIUM_SELLERS_WS_URL);
      wsRef.current = ws;

      useStrategyDashboardStore.getState().setWebSocketRef(ws);

      ws.onopen = () => {
        // console.log('[STRATEGY DASHBOARD WS] Connected');

        reconnectAttemptsRef.current = 0;

        useStrategyDashboardStore.getState().setConnected(true);
        useStrategyDashboardStore.getState().clearError();

        sendAuth(ws);
      };

      ws.onmessage = event => {
        try {
          const message = JSON.parse(event.data);

          if (message.type === 'AUTH_OK') {
            // console.log('[STRATEGY DASHBOARD WS] Auth OK:', message);

            useStrategyDashboardStore.getState().setAuthenticated(true);
            useStrategyDashboardStore.getState().clearError();
            return;
          }

          if (message.type === 'AUTH_ERROR') {
            // console.error('[STRATEGY DASHBOARD WS] Auth error:', message);

            authFailedRef.current = true;
            manuallyClosedRef.current = true;

            useStrategyDashboardStore.getState().setConnected(false);
            useStrategyDashboardStore.getState().setAuthenticated(false);
            useStrategyDashboardStore.getState().setWebSocketRef(null);

            useStrategyDashboardStore
              .getState()
              .setError(message.message || 'Strategy dashboard authentication failed');

            ws.close();
            return;
          }

          if (message.type === 'strategy_dashboard_snapshot') {
            logStrategyPayload(message);

            useStrategyDashboardStore.getState().setSnapshot(message);
            return;
          }

          if (message.type === 'ERROR') {
            // console.error('[STRATEGY DASHBOARD WS] Server error:', message);

            useStrategyDashboardStore
              .getState()
              .setError(message.message || 'Strategy dashboard server error');

            return;
          }

          // console.log('[STRATEGY DASHBOARD WS] Unhandled message:', message);
        } catch (error) {
          // console.error('[STRATEGY DASHBOARD WS] Failed to parse message:', error);

          useStrategyDashboardStore
            .getState()
            .setError('Failed to parse strategy dashboard message');
        }
      };

      ws.onerror = error => {
        // console.error('[STRATEGY DASHBOARD WS] Error:', error);

        useStrategyDashboardStore
          .getState()
          .setError('Strategy dashboard websocket error');
      };

      ws.onclose = event => {
        // console.log('[STRATEGY DASHBOARD WS] Closed:', {
        //   code: event.code,
        //   reason: event.reason,
        //   wasClean: event.wasClean,
        // });

        wsRef.current = null;

        useStrategyDashboardStore.getState().setConnected(false);
        useStrategyDashboardStore.getState().setAuthenticated(false);
        useStrategyDashboardStore.getState().setWebSocketRef(null);

        if (manuallyClosedRef.current || authFailedRef.current) {
          return;
        }

        const attempts = reconnectAttemptsRef.current + 1;
        reconnectAttemptsRef.current = attempts;

        const delay = Math.min(1000 * attempts, 10000);

        // console.log(
        //   `[STRATEGY DASHBOARD WS] Reconnecting in ${delay}ms... attempt=${attempts}`
        // );

        reconnectTimerRef.current = setTimeout(connect, delay);
      };
    }

    connect();

    return () => {
      manuallyClosedRef.current = true;

      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
      }

      if (wsRef.current) {
        // console.log('[STRATEGY DASHBOARD WS] Closing client');
        wsRef.current.close();
      }

      store.setConnected(false);
      store.setAuthenticated(false);
      store.setWebSocketRef(null);
    };
  }, []);

  return null;
}